import { ExIcon, IconVariant } from '@boomi/exosphere';
import { useNavigate } from 'react-router-dom';
import { HEADER_ICON_MAPPING } from '../../../constants/graph';
import type { TabType } from '../../../types/tab';
import { generateRouteUrl } from '../../../utils/routing';

interface DropdownListButtonProps {
    navigateTo: TabType;
    buttonText: string;
    buttonSummary: string;
    icon: string;
    visible: boolean;
}

const DropdownListButton = ({
    navigateTo,
    buttonText,
    buttonSummary,
    icon,
    visible,
}: DropdownListButtonProps) => {
    const navigate = useNavigate();

    const openAdminTab = (type: TabType) => {
        const route = generateRouteUrl({
            tabType: type,
        });

        navigate(route);
    };

    if (!visible) {
        return null;
    }

    return (
        <button className="dropdown-link" onClick={() => openAdminTab(navigateTo)} type="button">
            <ExIcon
                className="icon-large dropdown-link-icon"
                icon={HEADER_ICON_MAPPING[icon]}
                label={buttonText}
                variant={IconVariant.DEFAULT}
            />
            <div className="dropdown-content">
                {buttonText}
                <p>{buttonSummary}</p>
            </div>
        </button>
    );
};

export default DropdownListButton;
